export const english = {
    lang: 'en',
    data: {
        Menu: {
            Project: 'Project',
            Tag: 'Tag',
            Department: 'Department',
            Employees: 'Employees',
            BasicInformation: 'Basic information',
            ContactType: 'Contact Type',
            ApplicationSetting: 'Application setting',
            Employee: 'Employee',
            AddEmployee: 'Add employee',
            EmployeeList: 'Employee list',
            Customer: 'Customer',
            AddCustomer: 'Add customer',
            CustomerList: 'Customer list',
            Dashboard: 'Dashboard',
            Ticket: 'Ticket',
            AddTicket: 'Add ticket',
            TicketList: 'Ticket list',
            TicketType: 'Ticket type',
            Board: 'Scrum board',
            Country: 'Country',
            Province: 'Province',
            District: 'District',
            OfficeEquipmentType: 'Office equipment type',
            OfficeEquipment: 'Office equipment',
            AddOfficeEquipment: 'Add office equipment',
            OfficeEquipmentList: 'Office equipment list',
            TakeLeave: 'Take leave',
            AddTakeLeave: 'Add leave day',
            TakeLeaveList: 'Leave day list',
            OfficeEquipmentBrand: 'Office equipment brand',
            OfficeEquipmentModel: 'Office equipment model',
            projects: 'Projects',
            MeetingRoom: 'Meeting room',
            MeetingRoomSchedule: 'Meeting room schedule',
            Calendar: 'Calendar',
            EmployeeBoard: 'Employee board',
            CargoIntegration: 'Cargo integration',
            ERP: 'ERP',
            Module: 'Module',
            VirtualPos: 'Virtual pos',
            CustomerInformation: 'customer information',
            Reports: 'Reports',
            TicketReports: 'Ticket Reports',
            OpenTicketList: 'Open Ticket List',
            ClosedTicketList: 'Close Ticket List',
            assignedEmployeeCountList: 'Assigned Employee Count List',
            employeeCloseTicket: 'Employee close ticket'
        },
        projects: 'Projects',
        Abstentions: 'Convert all to abstentions',
        Department: 'Department',
        AddDepartment: 'Add department',
        EditDepartment: 'Edit department',
        DeleteDepartment: 'Delete department',
        DepartmentList: 'Department list',
        ApplicationSetting: 'Application setting',
        Email: 'Email',
        Password: 'Password',
        Host: 'Host',
        Port: 'Port',
        SSLCertificate: 'SSL Certificate',
        Search: 'Search',
        Actions: 'Actions',
        FirstName: 'First name',
        LastName: 'Last Name',
        CellphoneNumber: 'Cellphone Number',
        Username: 'Username',
        ChangePassword: 'Change password',
        passwordIsInvalid: 'Password is invalid. Password must contain at least eight characters, at least one number and both lower and uppercase letters and special characters.',
        ConfirmPassword: 'Confirm password',
        confirmPasswordIsInvalid: 'Confirm password does not match.',
        ChangePersonalInformation: 'Change personal information',
        EmailIsInvalid: 'Email is invalid.',
        SelectAll: 'Select all',
        SelectNone: 'Select none',
        PleaseCompleteTheForm: 'Please complete the form.',
        Id: 'Id',
        IsDeleted: 'Is deleted',
        Name: 'Name',
        Description: 'Description',
        DateTime: 'Date and time',
        Ascending: 'Ascending',
        Descending: 'Descending',
        Employee: 'Employee',
        RememberMe: 'Remember me',
        SignIn: 'Sign in',
        SignUp: 'Sign up',
        WelcomeToEryazTicketing: 'Welcome To Osa ticketing!',
        EryazTicketing: 'Osa ticketing',
        Notifications: 'Notifications',
        New: 'New',
        AccessDenied: 'Access denied',
        TaxNumber: 'Tax number',
        PersonalInformation: 'Personal information',
        AddPersonalInformation: 'Add personal information',
        ForgotPassword: 'Forgot password?',
        First: 'First',
        Prev: 'Prev',
        Next: 'Next',
        Last: 'Last',
        Send: 'Send',
        BackToLogin: 'Back to login',
        AnUnexpectedErrorOccurredWhileUploadingFile: 'An unexpected error occurred while uploading file',
        AnEmployeeWithThisUsernameAlreadyExists: 'An employee with this username already exists',
        AnEmployeeWithThisNationalIdentityAlreadyExists: 'An employee with this national identity already exists',
        UsernameOrPasswordIsNotCorrect: 'Username or password is not correct',
        UserIsNotLogin: 'User is not logged in',
        TheFileSizeIsBiggerThan3mb: 'The file size is bigger than 3mb.',
        TheAddOperationWasCompletedSuccessfully: 'The add operation was completed successfully.',
        TheEditOperationWasCompletedSuccessfully: 'The edit operation was completed successfully.',
        TheDeleteOperationWasCompletedSuccessfully: 'The delete operation was completed successfully.',
        AreYouSureYouWantToDeleteTheItem: 'Are you sure you want to delete the item?',
        CustomerLogo: 'Customer\'s logo',
        WebsiteAddress: 'Website address',
        Add: 'Add',
        Edit: 'Edit',
        Delete: 'Delete',
        Cancel: 'Cancel',
        MyInformation: 'My information',
        Logout: 'Logout',
        Information: 'Information',
        Image: 'Image',
        Order: 'Order',
        IdentificationNumber: 'Identification Number',
        AnAccountWithThisIdentificationNumberAlreadyExists: 'An account with this national identity code already exists',
        IsActive: 'Is active',
        Title: 'Title',
        Customers: 'Customers',
        Customer: 'Customer',
        AddCustomer: 'Add customer',
        EditCustomer: 'Edit customer',
        DeleteCustomer: 'Delete customer',
        CustomerList: 'Customer list',
        Contact: 'Contact',
        ContactTypeName: 'Contact type name',
        AddContactType: 'Add contact type',
        EditContactType: 'Edit contact type',
        DeleteContactType: 'Delete contact type',
        ContactTypeList: 'Contact type list',
        ContactType: 'Contact type',
        ContactTypeEnum: 'Contact type',
        PleaseSelectAnyItem: '-------- Please select any item -------',
        AddContact: 'Add contact',
        PleaseAddContact: 'Please add contact!',
        AddEmployee: 'Add employee',
        EditEmployee: 'Edit employee',
        DeleteEmployee: 'Delete employee',
        EmployeeList: 'Employee list',
        PleaseAddEmployee: 'Please add employee!',
        AddEmployeeContact: 'Add employee contact',
        FullName: 'Full name',
        Address: 'Address',
        Alert: 'Alert',
        PleaseCompleteAllRequiredFields: 'Please complete all required fields.',
        EmployeeContact: 'Employee contact',
        Fax: 'Fax',
        Website: 'Web site',
        PhoneNumber: 'Phone number',
        Other: 'Other',
        IsDefault: 'Default',
        EmailDoesNotExists: 'Email does not exists',
        AnAccountWithThisUsernameAlreadyExists: 'An account with this username already exists',
        CustomerEmployee: 'Customer employee',
        AddCustomerEmployee: 'Add customer employee',
        EditCustomerEmployee: 'Edit customer employee',
        DeleteCustomerEmployee: 'Delete customer employee',
        CustomerEmployeeList: 'Customer employee list',
        Code: 'Code',
        CreationDateTime: 'Creation date and time',
        EryazTicketingMenu: 'Osa Ticketing',
        PersonalPicture: 'Personal picture',
        Gender: 'Gender',
        Female: 'Female',
        Male: 'Male',
        BirthDate: 'Birth date',
        NationalIdentity: 'Identification number',
        AnAccountWithThisNationalIdentityAlreadyExists: 'An account with this national identity code already exists',
        AllTickets: 'All tickets',
        ClosedTickets: 'Closed tickets',
        ActiveTickets: 'Active tickets',
        Project: 'Project',
        AddProject: 'Add project',
        EditProject: 'Edit project',
        DeleteProject: 'Delete project',
        ProjectList: 'Project list',
        Tag: 'Tag',
        AddTag: 'Add tag',
        EditTag: 'Edit tag',
        DeleteTag: 'Delete tag',
        TagList: 'Tag list',
        TicketType: 'Ticket type',
        AddTicketType: 'Add ticket type',
        EditTicketType: 'Edit ticket type',
        DeleteTicketType: 'Delete ticket type',
        TicketTypeList: 'Ticket type list',
        Ticket: 'Ticket',
        AddTicket: 'Add ticket',
        EditTicket: 'Edit ticket',
        DeleteTicket: 'Delete ticket',
        TicketList: 'Ticket list',
        Attach: 'Attach a file',
        Priority: 'Priority',
        Comment: 'Comment',
        Status: 'Status',
        Active: 'Active',
        InProgress: 'In progress',
        Closed: 'Closed',
        VeryHigh: 'Very high',
        High: 'High',
        Medium: 'Medium',
        Low: 'Low',
        VeryLow: 'Very low',
        CreatorUserFullName: 'Creator full name',
        IsPublic: 'Is public',
        SubTask: 'Sub task',
        AddSubTask: 'Add sub task',
        EditSubTask: 'Edit sub task',
        DeleteSubTask: 'Delete sub task',
        CloseTicket: 'Close ticket',
        ShowSubTasks: 'Show sub tasks',
        HideSubTasks: 'Hide sub tasks',
        SubTasks: 'Sub tasks',
        Assignee: 'Assignee',
        Tickethistory: 'Ticket history',
        FormData: 'From date',
        ToDate: 'To date',
        UpdateTicketStatus: 'Update ticket status',
        UpdateAssignee: 'Update assignee',
        Unassigned: 'Unassigned',
        ToDo: 'To do',
        Done: 'Done',
        CarbonCopy: 'C.C',
        BlindCarbonCopy: 'B.C.C',
        TicketDetail: 'Ticket detail',
        SubTaskDetail: 'Sub task detail',
        DepartmentName: 'Department name',
        TeamLead: 'Team lead',
        AddCountry: 'Add country',
        EditCountry: 'Edit country',
        DeleteCountry: 'Delete country',
        CountryList: 'Country list',
        AddProvince: 'Add province',
        EditProvince: 'Edit province',
        DeleteProvince: 'Delete province',
        ProvinceList: 'Province list',
        AddDistrict: 'Add district',
        EditDistrict: 'Edit district',
        DeleteDistrict: 'Delete district',
        DistrictList: 'District list',
        Country: 'Country',
        Province: 'Province',
        District: 'District',
        DistrictName: 'District Name',
        ProvinceName: 'Province Name',
        CountryName: 'Country Name',
        PostalCode: 'Postal code',
        CustomerAddressType: 'Customer address type',
        BusinessRole: 'Business role',
        AddBusinessRole: 'Add business role',
        EditBusinessRole: 'Edit business role',
        DeleteBusinessRole: 'Delete business role',
        BusinessRoleList: 'Business role list',
        CustomerName: 'Customer name',
        TaxAdministration: 'Tax administration',
        AddAddress: 'Add address',
        PleaseAddAddress: 'Please add address',
        BillingAddress: 'Billing address',
        ShipmentAddress: 'Shipment address',
        ContactAddress: 'Contact address',
        SetProject: 'Set project',
        GetTicketsFromEmail: 'Get tickets from email',
        ReceiveEmailHost: 'Host for receiving email',
        ReceiveEmailPort: 'Port for receiving email',
        HasOpenSubtasks: 'Has open subtasks',
        Create: 'Create',
        Checked: 'Checked',
        Unchecked: 'Unchecked',
        AssignedEmployee: 'Assigned employee(ToDo)',
        UnassignedEmployee: 'Unassigned employee',
        AllowCloseTicket: 'Allow close ticket',
        AddTakeLeave: 'Add leave day',
        EditTakeLeave: 'Edit leave day',
        DeleteTakeLeave: 'Delete leave day',
        TakeLeaveList: 'Leave day list',
        AddOfficeEquipment: 'Add office equipment',
        EditOfficeEquipment: 'Edit office equipment',
        DeleteOfficeEquipment: 'Delete office equipment',
        OfficeEquipmentList: 'Office equipment list',
        OfficeEquipmentType: 'Office equipment type',
        AddOfficeEquipmentType: 'Add office equipment type',
        EditOfficeEquipmentType: 'Edit office equipment type',
        DeleteOfficeEquipmentType: 'Delete office equipment type',
        OfficeEquipmentTypeList: 'Office equipment type list',
        OfficeEquipmentBrand: 'Office equipment brand',
        AddOfficeEquipmentBrand: 'Add office equipment brand',
        EditOfficeEquipmentBrand: 'Edit office equipment brand',
        DeleteOfficeEquipmentBrand: 'Delete office equipment brand',
        OfficeEquipmentBrandList: 'Office equipment brand list',
        OfficeEquipmentModel: 'Office equipment model',
        AddOfficeEquipmentModel: 'Add office equipment model',
        EditOfficeEquipmentModel: 'Edit office equipment model',
        DeleteOfficeEquipmentModel: 'Delete office equipment model',
        OfficeEquipmentModelList: 'Office equipment model list',
        TakeLeave: 'Take leave',
        TakeLeaveType: 'Take leave type',
        FromDateTime: 'From date and time',
        ToDateTime: 'To date and time',
        CasualAnnualLeave: 'Casual annual leave',
        SabbaticalLeave: 'Sabbatical leave',
        UnpaidLeave: 'Unpaid leave',
        SickLeave: 'Sick leave',
        BereavementLeave: 'Bereavement leave',
        MaternityLeave: 'Maternity leave',
        PaternityLeave: 'Paternity leave',
        MilitaryLeave: 'Military leave',
        GiftLeave: 'Gift leave',
        SelfQuarantineLeave: 'Self-Quarantine leave',
        EmployeeFullName: 'Employee full name',
        GivenDateTime: 'Given date and time',
        OfficeEquipmentTypeName: 'Office equipment type name',
        ReturnDateTime: 'Return date and time',
        IsAccepted: 'Is accepted',
        ApproverFullName: 'Approver full name',
        AlertModalConfirmOrRejectMessage: 'Do you approve the leave request?',
        TransactionCompletedSuccessfully: 'Transaction completed successfully',
        AcceptOrReject: 'Accept or reject',
        Accept: 'Accept',
        Reject: 'Reject',
        PleaseSelectAProject: 'Please select a project',
        TheSelectedProjectIsNotBelongToTheCustomer: 'The selected project is not belong to the customer',
        ProjectChecklist: 'Project checklist',
        AddProjectChecklist: 'Add project checklist',
        EditProjectChecklist: 'Edit project checklist',
        DeleteProjectChecklist: 'Delete project checklist',
        ProjectChecklistList: 'Project checklist list',
        History: 'History',
        ProjectCompletionOrOngoing: 'Project completion or ongoing',
        Ongoing: 'Ongoing',
        Remained: 'Remained',
        StartProject: 'Start project',
        AddStartProject: 'Add start-project',
        DeleteStartProject: 'Delete start-project',
        StartProjectList: 'Start-project list',
        UpdateAssigneeForStartProject: 'Update assignee for start project',
        StartProjectDetail: 'Process list',
        AddStartProjectDetail: 'Add process list',
        EditStartProjectDetail: 'Edit process list',
        DeleteStartProjectDetail: 'Delete process list',
        UpdateAssigneeForStartProjectDetail: 'Update assignee for project detail',
        UpdateProjectStatus: 'Update project status',
        MeetingRoom: 'Meeting room',
        AddMeetingRoom: 'Add meeting room',
        EditMeetingRoom: 'Edit meeting room',
        DeleteMeetingRoom: 'Delete meeting room',
        MeetingRoomList: 'Meeting room list',
        MeetingRoomSchedule: 'Meeting room schedule',
        AddMeetingRoomSchedule: 'Add meeting room schedule',
        EditMeetingRoomSchedule: 'Edit meeting room schedule',
        DeleteMeetingRoomSchedule: 'Delete meeting room schedule',
        MeetingRoomScheduleList: 'Meeting room schedule list',
        Filter: 'Filter',
        Color: 'Color',
        MeetingRoomScheduleUsername: 'Meeting room schedule username',
        MeetingRoomSchedulePassword: 'Meeting room schedule password',
        AddCargoIntegration: 'Add cargo integration',
        EditCargoIntegration: 'Edit cargo integration',
        DeleteCargoIntegration: 'Delete cargo integration',
        CargoIntegrationList: 'Cargo integration list',
        AddERP: 'Add ERP',
        EditERP: 'Edit ERP',
        DeleteERP: 'Delete ERP',
        ERPList: 'ERP list',
        AddModule: 'Add module',
        EditModule: 'Edit module',
        DeleteModule: 'Delete module',
        ModuleList: 'Module list',
        AddVirtualPos: 'Add virtual pos',
        EditVirtualPos: 'Edit virtual pos',
        DeleteVirtualPos: 'Delete virtual pos',
        VirtualPosList: 'Virtual pos list',
        CargoIntegration: 'Cargo integration',
        ERP: 'ERP',
        Module: 'Module',
        VirtualPos: 'Virtual pos',
        CustomerInformation: 'customer information',
        AllProjects: 'All projects',
        EditDateTime: 'Edit Date Time',
        YorumAciklama: 'Please detail your description, add a picture if any.',
        AllowStatusChange : 'Allow status change',
        projectCompanyList : 'Company project list',
        ElapsedTime : 'Elapsed time',
        ClosedTicketCount : 'Closed ticket count',
        OpenTicketCount : 'Open ticket count',
        AssignedEmployeeCountList : 'Assigned Employee Count List',
        TicketCount : 'Ticket count',
        UpdateComment : 'Update comment',
        ProjectDetail : 'Project Detail',
        Level0 : 'Not determined',
        Level1 : 'Call/Resolution',
        Level2 : 'Call/Support',
        Level3 : 'Call/Software',
        Level4 : 'Software/Development',
        AddSubTicket : 'Add Sub Ticket',
        Cancelled : 'Cancelled'
    }
};
